// Used only by the Jenkins "development" deploy build (ng build --configuration
// development-deploy), never by local `ng serve`. matiyari's firewall opens 3040
// directly and PROTOCOL_OPTIONS on the API is loaded from erpdev.svayamtech.com's
// own cert, so the API must be addressed by that same hostname or the browser will
// also reject the TLS cert as a mismatch.
export const environment = {
  production: false,
  apiBaseUrl: 'https://erpdev.svayamtech.com:3040',
};
